export default __webpack_public_path__ + "static/media/at.f667dc3b.jpg";